// extracted by mini-css-extract-plugin
module.exports = {"product":"product-module--product--3OGcT","product__main":"product-module--product__main--1WM-b"};